/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_State_OrderInputs */

const en_wb_state_order = /** @type {(inputs: Wb_State_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order prepared. Waiting for a missing address.`)
};

const lv_wb_state_order = /** @type {(inputs: Wb_State_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasūtījums sagatavots. Gaida trūkstošo adresi.`)
};

/**
* | output |
* | --- |
* | "Order prepared. Waiting for a missing address." |
*
* @param {Wb_State_OrderInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_state_order = /** @type {((inputs?: Wb_State_OrderInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_State_OrderInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_state_order(inputs)
	return en_wb_state_order(inputs)
});